import { NextApiRequest, NextApiResponse } from 'next';
import cookie from 'cookie';

export function isServerSide() {
  return typeof window === 'undefined';
}
